<template>
  <van-index-bar :index-list="indexList">
    <div
      class="vant-content"
      v-for="(item, index) in modelList"
      :key="item.modelId"
      :id="item.modelId"
      align="center"
    >
      <van-cell
        :class="{
          'van-cell': true,
          'van-cell-1': index === modelList.length - 1
        }"
        @click="chooseCarBrandFn(item)"
        >{{ item.modelName }}</van-cell
      >
    </div>
  </van-index-bar>
</template>

<script>
import { modelListFn } from "@/services/C2C";
import Vue from "vue";
import { IndexBar, IndexAnchor, Cell } from "vant";

Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Cell);

export default {
  data() {
    return {
      modelList: [],
      indexList: []
    };
  },
  mounted() {
    this.fnGetBrandList();
  },
  methods: {
    fnGetBrandList() {
      const data = { brandId: this.$route.query.brandId || "B03" };
      modelListFn(data).then(res => {
        if (res.code === 200) {
          this.modelList = res.result.modelList;
        }
      });
    },
    chooseCarBrandFn(ele) {
      const { modelName, modelId } = ele;
      //判断是否在小程序环境
      if (window.__wxjs_environment === "miniprogram") {
        const {brandId, brandName, name='', phone='', code='',utm_source='',utm_medium='', scrollTop=0} = this.$route.query;
        const params = `?name=${name}&phone=${phone}&code=${code}&scrollTop=${scrollTop}&modelName=${modelName}&modelId=${modelId}&brandId=${brandId}&brandName=${brandName}&utm_source=${utm_source}&utm_medium=${utm_medium}`;
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({
          url: "/pages/c2cInvite/C2CInvite" + params
        });
      } else {
        this.$router.push({
          path: "/C2C/landPage",
          query: {
            ...this.$route.query,
            modelName: modelName,
            modelId: modelId
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.vant-content {
  .van-cell {
    width: 670px;
    height: 82px;
    line-height: 82px;
    display: block;
    text-align: left;
    border-bottom: 2px solid #f1f3f5;
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #141e25;
    letter-spacing: 0;
  }
  .van-cell-1 {
    border-bottom: none;
  }
}
</style>
